/**
 * 
 * key
 * 
 */

//  dmlld2VtcGxveWVl
const key = 'dmlld2VtcGxveWVl'

export default key 